export const ANNUAL_REVIEWS_NEW = 'annual-reviews';
